/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste any text and see which words appear most often — ranked with counts and bars. Filter short words and limit to the top results.`)
};

const es_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega cualquier texto y ve qué palabras aparecen más a menudo — ordenadas con conteos y barras. Filtra palabras cortas y limita a los resultados principales.`)
};

const de_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie einen beliebigen Text ein und sehen Sie, welche Wörter am häufigsten vorkommen — sortiert mit Anzahl und Balken. Kurze Wörter filtern und auf die Top-Ergebnisse beschränken.`)
};

const nl_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak elke tekst in en zie welke woorden het meest voorkomen — gerangschikt met aantallen en balken. Filter korte woorden en beperk tot de beste resultaten.`)
};

const fr_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez n'importe quel texte et voyez quels mots apparaissent le plus souvent — classés avec des compteurs et des barres. Filtrez les mots courts et limitez les résultats supérieurs.`)
};

const it_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla qualsiasi testo e vedi quali parole appaiono più spesso — classificate con conteggi e barre. Filtra le parole corte e limita ai migliori risultati.`)
};

const pt_br2_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole qualquer texto e veja quais palavras aparecem com mais frequência — classificadas com contagens e barras. Filtre palavras curtas e limite aos melhores resultados.`)
};

const pt_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole qualquer texto e veja quais palavras aparecem mais vezes — classificadas com contagens e barras. Filtre palavras curtas e limite aos melhores resultados.`)
};

const ja_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のテキストを貼り付けて、最も頻繁に出現する単語を確認します—カウント数とバーでランク付けされています。短い単語をフィルタリングし、上位の結果に制限します。`)
};

const zh_wf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴任意文本，查看出现频率最高的单词——以计数和条形图排名显示。可过滤短单词，并限制只显示排名靠前的结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_intro", locale)
	if (locale === "en") return en_wf_intro(inputs)
	if (locale === "es") return es_wf_intro(inputs)
	if (locale === "de") return de_wf_intro(inputs)
	if (locale === "nl") return nl_wf_intro(inputs)
	if (locale === "fr") return fr_wf_intro(inputs)
	if (locale === "it") return it_wf_intro(inputs)
	if (locale === "pt-BR") return pt_br2_wf_intro(inputs)
	if (locale === "pt") return pt_wf_intro(inputs)
	if (locale === "ja") return ja_wf_intro(inputs)
	return zh_wf_intro(inputs)
};